import { filter } from 'rxjs';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { ProductService } from 'app/core/product/product.service';
import { Router } from '@angular/router';
import { FiltersService } from 'app/core/filters/filters.service';
@Component({
  selector: 'nav-sidebar',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './nav-sidebar.component.html',
  styleUrl: './nav-sidebar.component.scss'
})
export class NavSidebarComponent {
  @Output() close = new EventEmitter<void>();
  @Input() menuKey!: string;
  @ViewChild('top') titleElement!: ElementRef;
  type: any;
  categories: any[] = [];
  brands: any[] = [];
  opened = true;
  childs: any[] = [];
  enableChilds = false;
  titleChild= '';
  titleMain = '';
  father: any;
  filterBrand: any;
  filterCategory: any;

  constructor(
    private _productService: ProductService,
    private _router: Router,
    private _filtersService: FiltersService,
    ) {
    this._filtersService.filtersChanged$.subscribe((filters) => {
      this.filterBrand = filters.brands || [];
      this.filterCategory = filters.categories || [];
      // this._cdr.detectChanges();
      });
  }



  ngOnChanges(changes: SimpleChanges): void {

    const filters = localStorage.getItem('filtersProducts');
    this.filterBrand = JSON.parse(filters || '{}').brands;
    this.filterCategory = JSON.parse(filters || '{}').categories;


    if (changes['menuKey'] && changes['menuKey'].currentValue) {
      this.loadDataForMenu(changes['menuKey'].currentValue);
    }
  }

  private loadDataForMenu(key: string): void {
    this.type = key;
    this._productService.getNavMenu({}).subscribe((res) => {
      if (res.status){
        this.categories = res.data.categories || [];
        this.brands = res.data.brands || [];
      }
    });

  }

  onCategoryClick(type: string, child: any = false): void {
    if (this.type == "brands"){
      const matchedBrand = this.brands.find(brand => brand.code === type);
      this.titleMain = matchedBrand?.name || '';
      localStorage.setItem('filtersProducts', JSON.stringify({
        brands: [type],
        categories: [],
        max_price: 999999,
        min_price: 0,
        search: '',
        }));
      const filters = localStorage.getItem('filtersProducts');
      const parsed = JSON.parse(filters || '{}');
      this.filterBrand = Array.isArray(parsed?.brands) ? parsed.brands : [];

      const extras = { queryParams: { type: matchedBrand.name } };
      if (this._router.url.startsWith('/products-brands')) {
        this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this._router.navigate(['/products-brands'], extras);
        });
      } else {
        this._router.navigate(['/products-brands'], extras);
      }
    }
    if (this.type == "categories"){
      this.scrollToTop();
      const categoryId = Number(type);
      let matchedCategory: any;
      let matchedCategoryChild: any;
      if(child === false){
        matchedCategory = this.categories.find(
          (cat) => cat.id === categoryId
        );
      } else {
        matchedCategoryChild = this.childs.find(
          (cat) => cat.id === categoryId
        );
        this.titleChild = this.father + ' / ' + matchedCategoryChild.name;
      }
      this.titleMain = matchedCategory?.name || '';
      if (matchedCategory && matchedCategory.childs.length > 0) {
        this.enableChilds = true;
        this.childs = matchedCategory.childs;
        this.father = matchedCategory.name
      }else{
        localStorage.setItem('filtersProducts', JSON.stringify({
          brands: [],
          categories: [type],
          max_price: 999999,
          min_price: 0,
          search: '',
        }));
        const filters = localStorage.getItem('filtersProducts');
        const parsed = JSON.parse(filters || '{}');
        this.filterCategory = Array.isArray(parsed?.categories) ? parsed.categories : [];
        const extras = { queryParams: { type: this.titleMain || this.titleChild } };
        if (this._router.url.startsWith('/products-categories')) {
          this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this._router.navigate(['/products-categories'], extras);
          });
        } else {
          this._router.navigate(['/products-categories'], extras);
        }
      }
    }
  }

  scrollToTop(): void {
    this.titleElement.nativeElement.scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  onClose(): void {
    this.enableChilds = false;
    this.close.emit();
  }

  onCloseChilds(): void {
    this.enableChilds = false;
  }
}